import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/core/endpointsAndGeneric-constants/api-constants';
import { HttpMethodModifierService } from 'src/app/core/http-method-modifier.service';

@Injectable({
  providedIn: 'root'
})
export class HomeDashboardService {

  constructor(private httpGuard: HttpMethodModifierService) { }

  devicesSummary(loaderNeeded: boolean = false) {
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.deviceSummaryV2, null, loaderNeeded);
  }

  templatesSummary(loaderNeeded: boolean = false) {
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.templatesSummaryV2, null, loaderNeeded);
  }

  batchesSummary(loaderNeeded: boolean = false) {
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.batchesSummaryV2, null, loaderNeeded);
  }

  getBatchScheduledGeneratedMetrics(scheduled : boolean, generated: boolean, timeZone: string) {
    let httpParams = new HttpParams();
    if (scheduled) {
      httpParams = httpParams?.set('scheduled', scheduled);
    }
    if (generated) {
      httpParams = httpParams?.set('generated', generated);
    }
    if (timeZone) {
      httpParams = httpParams?.set('timezone', timeZone);
    }
    return this.httpGuard?.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.getBatchPayloadMetricsV2, httpParams?.toString() ? '?' + httpParams?.toString() : null , false);
  }
}
